"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../../../..");
var _StepBar = require("../../StepBar.helper");
var _DefaultStepBarItem = _interopRequireDefault(require("../DefaultStepBarItem"));
var S = _interopRequireWildcard(require("./DefaultStepBar.style"));
var _excluded = ["step", "steps", "disableClickEvent", "onItemClick"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DefaultStepBar = function DefaultStepBar(_ref) {
  var step = _ref.step,
    steps = _ref.steps,
    disableClickEvent = _ref.disableClickEvent,
    onItemClick = _ref.onItemClick,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(S.StepBar, props, /*#__PURE__*/_react["default"].createElement(S.StepsList, null, steps.map(function (stepItem, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_DefaultStepBarItem["default"], {
      buttonText: "".concat(index + 1),
      labelText: stepItem,
      stepPosition: (0, _StepBar.getPosition)(index, step),
      disableClickEvent: disableClickEvent,
      onClick: function onClick(event) {
        if (disableClickEvent) {
          event === null || event === void 0 || event.preventDefault();
        } else {
          onItemClick(index);
        }
      }
    }));
  })), /*#__PURE__*/_react["default"].createElement(S.Progress, null, /*#__PURE__*/_react["default"].createElement(_.Progress, {
    value: (0, _StepBar.getProgressAt)(step, steps.length)
  })));
};
DefaultStepBar.propTypes = {
  step: _propTypes["default"].number,
  steps: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onItemClick: _propTypes["default"].func,
  disableClickEvent: _propTypes["default"].bool
};
var _default = exports["default"] = DefaultStepBar;